export enum RecommendationType {
  HEALTH = 'health',
  ACTION = 'action',
}
